module.exports = __webpack_public_path__ + "img/new_slide_2.1fdf504d.jpg";